import { createRoute } from "@tanstack/solid-router";
// FLAGS: la página entera se gatea por la vertical de tutorías (org activa).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { msg } from "@lingui/core/macro";
import { ClipboardCheck } from "lucide-solid";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer } from "@/components/ui/page-container";
import { PageHeader } from "@/components/ui/page-header";
import { TutorPanel } from "@/features/academy/tutor/tutor-panel";
// AUTONOMY · Layer 3: ayuda contextual de tutorías.

function TutoringPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="6xl">
      <div class="flex items-start justify-between gap-2">
        <PageHeader
          title={t(msg`Tutoring`)}
          description={t(
            msg`Review submissions from your cohorts against the SLA: return them with feedback or approve them. Students resubmit until approved.`,
          )}
          icon={ClipboardCheck}
        />
      </div>
      <div class="mt-4">
        <TutorPanel />
      </div>
    </PageContainer>
  );
}

export const academyTutoringRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/academy/tutoring",
  component: withFeatureGate("academy.tutoring", TutoringPage),
});
